var map = {
	"./group23-ct.png": "0931",
	"./group23-en.png": "0abc",
	"./group23-ja.png": "64b0",
	"./group23-ko.png": "41fe",
	"./group23-th.png": "004e",
	"./group23-vi.png": "ba7e",
	"./group23-zh.png": "1454"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f2f1";